// src/graphql/fragment-masking.ts
function getFragmentData(_documentNode, fragmentType) {
  return fragmentType;
}
function makeFragmentData(data, _fragment) {
  return data;
}
function isFragmentReady(queryNode, fragmentNode, data) {
  var _a, _b, _c;
  const deferredFields = (_a = queryNode.__meta__) == null ? void 0 : _a.deferredFields;
  const fragName = (_b = fragmentNode.__meta__) == null ? void 0 : _b.fragmentName;
  if (!deferredFields || !fragName) return true;
  const fields = (_c = deferredFields[fragName]) != null ? _c : [];
  return fields.length > 0 && fields.every((field) => data && field in data);
}

export { getFragmentData, isFragmentReady, makeFragmentData };
//# sourceMappingURL=chunk-KTM5ANUO.mjs.map
//# sourceMappingURL=chunk-KTM5ANUO.mjs.map